import * as ngCore from '@angular/core'

/**
 * The Tab component is used to display content in a tabbed manner.
 *
 * **Inputs**
 * - {@link AtnDsTabDirective.nameSg|name}!
 * - {@link AtnDsTabDirective.disabledSg|disabled}?
 * - {@link AtnDsTabDirective.isInitiallySelectedSg|isInitiallySelected}?
 *
 * @example
 * ```html
 *  <ng-template atnDsTab [name]="'Tab 1'" [isInitiallySelected]="true">
 *    <div>Tab 1 content</div>
 *  </ng-template>
 *
 * <!-- disabled tab -->
 *  <ng-template atnDsTab [name]="'Tab 2'" [disabled]="true">
 *    <div>Tab 2 content</div>
 *  </ng-template>
 * ```
 */
@ngCore.Directive({
  selector: '[atnDsTab]',
  standalone: true,
})
export class AtnDsTabDirective {
  /**
   * Name input
   */
  public readonly nameSg = ngCore.input.required<string>({ alias: 'name' })

  /**
   * Whether the tab is disabled.
   */
  public readonly disabledSg = ngCore.input<boolean | undefined>(false, {
    alias: 'disabled',
  })
  /**
   * Whether this tab should be selected when the tabs instance first initializes.
   */
  public readonly isInitiallySelectedSg = ngCore.input<boolean | undefined>(
    false,
    {
      alias: 'isInitiallySelected',
    },
  )

  constructor(public template: ngCore.TemplateRef<any>) {}
}
